import notificationsActions from './actionTypes';

export const hideNotification = () => {
  return notificationsActions.hideNotification();
};

export const showError = (message) => {
  return notificationsActions.showError(message);
};
